export default {
  add: "Add",
  apply: "Apply",
  assign: "Assign",
  attributeSets: "Attribute Sets",
  attributes: "Attributes",
  back: "Back",
  cancel: "Cancel",
  change: "Change",
  close: "Close",
  deploy: "Deploy",
  click: "Click",
  changeVersion: "Change Version",
  here: "here",
  toChangeThat: "to change that!",
  choose: "Choose",
  select: "Select",
  showDetails: "Show details",
  hideDetails: "Hide details",
  changePassword: "Change Password",
  confirm: "Confirm",
  continue: "Continue",
  create: "Create",
  createNewAttribute: "Create new attribute",
  createdBy: "created by",
  delete: "Delete",
  deleteSet: "Delete Set",
  done: "Done",
  edit: "Edit",
  editName: "Edit Name",
  editSet: "Edit Set",
  editVersion: "EDIT VERSION",
  logout: "Logout",
  new: "New",
  newLog: "New Log",
  next: "Next",
  no: "No",
  OK: "OK",
  deleteAnyway: "DELETE ANYWAY",
  remove: "Remove",
  replace: "replace",
  reserve: "Reserve",
  run: "Run",
  save: "Save",
  saveChanges: "Save Changes",
  send: "Send",
  settings: "Settings",
  sort: "Sort",
  submit: "Submit",
  unassign: "unassign",
  unselect: "Unselect",
  undoChanges: "Undo Changes",
  yes: "Yes",
};
